import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Login.vue'),
        meta: { guest: true }
    },
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Home.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/vouchers',
        name: 'Vouchers',
        component: () => import('@/views/Vouchers.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/complete-profile',
        name: 'CompleteProfile',
        component: () => import('@/views/CompleteProfile.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/settings',
        name: 'Settings',
        component: () => import('@/views/Settings.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '*',
        redirect: '/'
    }
];

const router = new VueRouter({
    mode: 'history',
    routes
});

let dataLoaded = false;

router.beforeEach(async (to, from, next) => {
    const isAuthenticated = store.getters['auth/isAuthenticated'];

    if (to.meta.requiresAuth && !isAuthenticated) {
        dataLoaded = false;
        return next({ name: 'Login' });
    }

    if (to.meta.guest && !isAuthenticated) {
        dataLoaded = false;
    }

    if (to.meta.guest && isAuthenticated) {
        return next({ name: 'Home' });
    }

    if (
        isAuthenticated &&
        !store.state.auth.profileCompleted &&
        to.name !== 'CompleteProfile'
    ) {
        return next({ name: 'CompleteProfile' });
    }

    if (to.meta.requiresAuth && isAuthenticated && !dataLoaded) {
        dataLoaded = true;
        store.dispatch('auth/loadLoyaltyData').catch(() => {
            dataLoaded = false;
        });
    }

    next();
});

export default router;
